import { useContext, useEffect } from 'react';
import { LoadingModalContext } from '../contexts/LoadingProvider';

const LoadingModal = () => {
  // loading context
  const { modal, showModal } = useContext(LoadingModalContext);
  const { show } = modal;
  useEffect(() => {
    if (show) {
      (document.getElementById('loading_modal') as HTMLFormElement)?.showModal();
    } else {
      (document.getElementById('loading_modal') as HTMLFormElement)?.close();
    }
  }, [show]);

  useEffect(() => {
    const handleKeyDown = (event: any) => {
      if (show) {
        event.preventDefault();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <dialog id="loading_modal" className="modal">
      <div className="modal-box max-w-sm p-2 sm:p-8">
        <div className="flex flex-row justify-center">
          <h3 className="font-bold text-xl text-primary">Loading...</h3>
        </div>
        <div className="divider m-0" />
        <div className="flex flex-row justify-center">
          <span className="loading loading-spinner loading-lg text-primary"></span>
        </div>
      </div>
    </dialog>
  );
};

export default LoadingModal;
